import api, { apiErrorMessage } from "./api";

/**
 * The team's read-only preview of the portal (22.10.2026): the server sets
 * the preview's own cookie, then the portal opens in a new tab as the person
 * sees it. The tab is opened before the request, while the click still counts,
 * so a pop-up blocker does not stop it.
 */
export async function openPreview(target, { onError } = {}) {
  const tab = window.open("", "_blank");
  try {
    await api.post("/admin/portal/preview",
      target.enrollmentId ? { enrollment_id: target.enrollmentId } : { trainer_id: target.trainerId });
    if (tab) tab.location.href = "/portal";
    else window.location.href = "/portal";
  } catch (err) {
    if (tab) tab.close();
    onError?.(apiErrorMessage(err, "Nu am putut deschide previzualizarea."));
  }
}

/** "se închide la 15:40" — the end of the preview, in Romania's time. */
export function untilLabel(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("ro-RO", { timeZone: "Europe/Bucharest", hour: "2-digit", minute: "2-digit" })
    .format(new Date(iso));
}

export function bannerLine(pv) {
  if (!pv) return "";
  const who = pv.role_label ? `${pv.name} (${pv.role_label})` : pv.name;
  return `Previzualizare: vezi portalul ca ${who} · doar citire · se închide la ${untilLabel(pv.expires_at)}`;
}
